import axios from "axios"

export default{
    async Table(data){
        const response = await axios.post('/api/documenttemplate/table/documenttemplateofcompany',data)
        return response
    },
    async Update(data){
        const response = await axios.post('/api/documenttemplate/update/companydocumenttemplatescheme',data)
        return response
    },
    async Get(data){
        const response = await axios.get(`/api/documenttemplate/get/documenttemplate/${data}`)
        return response
    },
}